/**
 * iVCEBlast Application Configuration
 */

import type { DropdownOption, SectionConfig } from '../shared';
import React from 'react';

export const APP_NAME = 'iVCEBlast';
export const APP_VERSION = '1.0.0';
export const APP_VERSION_POLICY = { currentVersion: APP_VERSION };

export const CONFINEMENT_OPTIONS: DropdownOption[] = [
  { value: 'Confined', label: 'Confined' },
  { value: 'UnConfined', label: 'UnConfined' }
];

export interface APIPayload {
  title: string;
  mass: number;
  LHV: number;
  mf: number;
  R: number;
  Confinement: string;
  V: string;
  A: string;
}

export interface APIResponse {
  R: number;
  Ri: number;
  Wi: number;
  Pi: number;
  Pr: number;
  Ii: number;
  Ir: number;
  Pbar: number;
  Patm: number;
  Rbar: number;
  Ibar: number;
  E: number;
  a0: number;
  td: number;
  iConfined: string;
  Wg: number;
  Ig: number;
  charts: {
    pressure?: { mime: string; base64: string };
    impulse?: { mime: string; base64: string };
  };
}

export const RESPONSE_DISPLAY_CONFIG: SectionConfig<APIResponse>[] = [
  {
    title: 'Primary Results',
    fields: [
      { label: 'E', getValue: data => `${data.E.toFixed(2)} mJ` },
      { label: React.createElement('span', null, 'P', React.createElement('sub', null, 'atm')), getValue: data => `${data.Patm.toFixed(3)} mPa` },
      { label: React.createElement('span', null, 'a', React.createElement('sub', null, '0')), getValue: data => `${data.a0.toFixed(2)} m/sec` },
      { label: React.createElement('span', null, 'R', React.createElement('sub', null, 'bar')), getValue: data => `${data.Rbar.toFixed(3)}` },
      { label: React.createElement('span', null, 'P', React.createElement('sub', null, 'bar')), getValue: data => `${data.Pbar.toFixed(3)} psi-ms` },
      { label: React.createElement('span', null, 'I', React.createElement('sub', null, 'bar')), getValue: data => `${data.Ibar.toFixed(3)} psi-ms` },
      { label: 'R', getValue: data => `${data.R.toFixed(2)} ft` }
    ]
  },
  {
    title: 'Scaled/Derived',
    fields: [
      { label: React.createElement('span', null, 'P', React.createElement('sub', null, 'i')), getValue: data => `${data.Pi.toFixed(3)} psi` },
      { label: React.createElement('span', null, 'I', React.createElement('sub', null, 'i')), getValue: data => `${data.Ii.toFixed(3)} psi-ms` },
      { label: React.createElement('span', null, 'P', React.createElement('sub', null, 'r')), getValue: data => `${data.Pr.toFixed(3)} psi` },
      { label: React.createElement('span', null, 'I', React.createElement('sub', null, 'r')), getValue: data => `${data.Ir.toFixed(3)} psi-ms` },
      { label: React.createElement('span', null, 'W', React.createElement('sub', null, 'g')), getValue: data => `${data.Wg.toFixed(3)} lb` },
      { label: React.createElement('span', null, 'P', React.createElement('sub', null, 'g')), getValue: data => `${data.Pi.toFixed(3)} psi` },
      { label: React.createElement('span', null, 'I', React.createElement('sub', null, 'g')), getValue: data => `${data.Ig.toFixed(3)} psi-msec` }
    ]
  }
];
